<template>
  <div class="widget-favourites">
    <HeadlineAction
      :title="headlineInfo.title"
      img="img//lobby/heart-title.svg"
      class="widget-favourites__title"
    />
    <ExpandList
      :key="term"
      :query-key="term"
      :fetch-method="fetch_subsectionItem"
      :param-page="term"
      :list-type="$options.static.LIST_TYPE.GAME.NAME"
      :prop-data="data"
      is-auto-pagination
    >
      <template #default>
        <MissingGames
          v-if="data && !data.games.result.length"
          :term="firstSectionInfo.term"
          src="/img/lobby/heart.webp"
          :desk="$t('lobby.favourites.empty')"
          :text="$t('lobby.favourites.emptyText', { br: '<br/>' })"
          :btn-text="$t('lobby.favourites.emptyBtn')"
          :link-text="firstSectionInfo.title"
        />
      </template>

      <template #last>
        <AddCard
          v-if="firstSectionInfo"
          :term="firstSectionInfo.term"
        />
      </template>
    </ExpandList>

    <div class="widget-favourites__add">
      <AddCard
        v-if="firstSectionInfo && data.games.result.length"
        :term="firstSectionInfo.term"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ExpandList from '~/components/Lobby/ExpandList'
import { LIST_TYPE } from '@/components/Lobby/enum.js'
import AddCard from '@/components/Lobby/UserGames/AddCard'
import MissingGames from '@/components/Lobby/MissingGames'
import { getLangText } from '@/components/Lobby/helpers.js'
import HeadlineAction from '@/components/shared/HeadlineAction'

export default {
  name: 'WidgetFavourites',
  components: {
    ExpandList,
    AddCard,
    MissingGames,
    HeadlineAction,
  },
  props: {
    term: { type: String },
    data: { type: Object },
  },
  static: {
    LIST_TYPE,
  },
  computed: {
    ...mapGetters('lobby', [
      'get_sectionList',
      'get_subsectionItem',
    ]),
    firstSectionInfo() {
      if (!this.get_sectionList.data) return
      const { term, nameUa, nameRu } = this.get_sectionList.data[0]

      return {
        term: this.localePath(`/${term}`),
        title: getLangText(nameUa, nameRu, this.$i18n ),
      }
    },
    headlineInfo() {
      return {
        img: `${this.$config.cloudUrl}${this.data.iconUrl}`,
        title: getLangText(this.data.nameUa, this.data.nameRu, this.$i18n),
      }
    },
  },
  methods: {
    ...mapActions('lobby', [
      'fetch_subsectionItem',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.widget-favourites {
  &__title {
    margin-bottom: var(--spaces-m);

    @include media(mobile-last) {
      margin-bottom: var(--spaces-xl);
    }
  }

  &__add {
    display: flex;
    margin-top: var(--spaces-s);

    @include media(tablet) {
      display: none;
    }
  }
}
</style>
